import React, { FC } from 'react'

import { IconAccelerationProps } from './IconAcceleration.types'
import * as Styled from './styles/IconAcceleration.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAcceleration: FC<IconAccelerationProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAccelerationProps['size'],
  isResponsive = false,
}: IconAccelerationProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M42.958 24.107a19 19 0 1 1-19-19h19v19Z' stroke='#fff' strokeWidth='2' />
        <path d='M36.69 20A13.447 13.447 0 0 0 11 21' stroke='#fff' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M11.043 21c1.207-4.68 5.322-8.125 10.207-8.125 4.55 0 8.415 2.943 9.907 7.125m.011 0h5.522'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M36.948 24.06H23.995m.042 1.058a1.118 1.118 0 1 0 0-2.235 1.118 1.118 0 0 0 0 2.235Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconAcceleration
